// Effects (§11.19): vignette after geometry (follows the crop, radial falloff in linear light) and grain
// at output (a seeded noise tile, added in the encoded domain after resize, scaled to the output size).
import { HEADER } from './common';

/** Vignette on a straight-alpha linear target that covers part of the output frame. */
export const VIGNETTE = `${HEADER}
uniform sampler2D uSrc;
uniform vec2 uOffset;   // this target's origin in full-output pixels
uniform vec2 uFull;     // full output size in pixels
uniform vec3 uVig;      // amount -100..100, midpoint 0..100, feather 0..100
out vec4 o;
void main() {
  vec4 c = texelFetch(uSrc, ivec2(gl_FragCoord.xy), 0);
  vec2 uv = (gl_FragCoord.xy + uOffset) / uFull;
  float d = length((uv - 0.5) * 2.0) / 1.41421356;   // 0 centre, 1 corners, elliptical with the frame
  float mid = uVig.y / 100.0;
  float fw = max(0.02, uVig.z / 100.0 * 0.5);
  float t = clamp((d - (mid - fw)) / (2.0 * fw), 0.0, 1.0);
  float m = t * t * (3.0 - 2.0 * t);
  c.rgb *= exp2(uVig.x / 100.0 * 1.5 * m);
  o = c;
}`;

/** Grain, shared by the canvas output pass and the export output pass. */
export const GRAIN_FNS = `
uniform sampler2D uGrain;    // 256² zero-mean noise tile, REPEAT
uniform float uGrainAmt;     // 0..1
uniform float uGrainCell;    // grain cell in full-output pixels
uniform vec4 uGrainMap;      // this pixel → full-output pixel: px * xy + zw
vec3 addGrain(vec3 e, vec2 px) {
  if (uGrainAmt <= 0.0) return e;
  vec2 q = (px * uGrainMap.xy + uGrainMap.zw) / (uGrainCell * 256.0);
  float g = texture(uGrain, q).r;
  float l = dot(e, vec3(0.2126, 0.7152, 0.0722));
  return clamp(e + uGrainAmt * 0.06 * g * (0.4 + 2.4 * l * (1.0 - l)), 0.0, 1.0);
}
`;
